export default __webpack_public_path__ + "static/media/treasure-logo.a56b66e0.jpeg";